// Heat transfer settings schema
// Defines thermal insulation layers and ambient conditions for pipe heat loss
// C++ source: heat_transfer_settings_serializer.h (BOOST_CLASS_VERSION 3)

import { z } from 'zod';
import { ValueWithUnitSchema } from '../base/common';

export const ThermalChoiceSchema = z.enum([
  'not_set',
  'prandtl',
  'thermal_conductivity',
  'convection_coefficient',
]);

export const HeatTransferCalcModeSchema = z.enum([
  'not_set',
  'constant_surface_temperature',
  'constant_heat_flux',
  'ambient',
]);

export const ThermalLayerSchema = z.object({
  material: z.string(),
  layer_level: z.number().int().optional(),
  thickness: ValueWithUnitSchema,
  thermal_conductivity: ValueWithUnitSchema,
});

export type ThermalLayer = z.infer<typeof ThermalLayerSchema>;

export const HeatTransferSettingsSchema = z.object({
  id: z.string(),
  name: z.string(),

  thermal_choice: ThermalChoiceSchema.optional(),
  calc_mode: HeatTransferCalcModeSchema.optional(),

  prandtl_number: ValueWithUnitSchema.optional(),
  thermal_conductivity: ValueWithUnitSchema.optional(),
  convection_coefficient: ValueWithUnitSchema.optional(),
  heat_flux: ValueWithUnitSchema.optional(),
  surface_temperature: ValueWithUnitSchema.optional(),

  layers: z.array(ThermalLayerSchema).optional(),

  ambient_temperature: ValueWithUnitSchema.optional(),
  external_convection_coefficient: ValueWithUnitSchema.optional(),
  ambient_heat_flux: ValueWithUnitSchema.optional(),
});

export type HeatTransferSettings = z.infer<typeof HeatTransferSettingsSchema>;
